export default function ImageScroller({ src }) {
  return (
    <div className="bg-primary-800 p-1 shrink-0 hover:contrast-125 transition-all cursor-crosshair">
      <img src={src} alt="Img" className="w-24 h-24" />
    </div>
  );
}
